(function () {
  const instances = new Map();
  let modalElements = null;
  const styleElementId = "product-image-zoom-styles";

  function ensureStyles() {
    if (document.getElementById(styleElementId)) return;

    const style = document.createElement("style");
    style.id = styleElementId;
    style.textContent = `
        .product-image-zoom-modal {
          position: fixed;
          inset: 0;
          z-index: 99999;
          display: none;
        }
        .product-image-zoom-modal.is-open {
          display: block;
        }
        .product-image-zoom-modal__backdrop {
          position: absolute;
          inset: 0;
          background: #ffffff;
        }
        .product-image-zoom-modal__close {
          position: fixed;
          top: calc(env(safe-area-inset-top, 0px) + 12px);
          right: calc(env(safe-area-inset-right, 0px) + 12px);
          z-index: 2;        
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #111111;
          border-radius: 999px;
          background: #ffffff;
          width: 48px;
          height: 48px;
          color: #111111;
          cursor: pointer;
        }
        .product-image-zoom-modal__close svg {
          width: 24px;
          height: 24px;
          display: block;
        }
        .product-image-zoom-modal__stage {
          position: absolute;
          inset: 0;
          overflow: hidden;
          cursor: zoom-in;
          touch-action: none;
        }
        .product-image-zoom-modal__loader {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 40px;
          height: 40px;
          margin-top: -20px;
          margin-left: -20px;
          border: 3px solid rgba(0, 0, 0, 0.2);
          border-top-color: #111111;
          border-radius: 999px;
          animation: product-image-zoom-spin 0.8s linear infinite;
          display: none;
          pointer-events: none;
          z-index: 1;
        }
        .product-image-zoom-modal.is-loading .product-image-zoom-modal__loader {
          display: block;
        }
        .product-image-zoom-modal.is-loading .product-image-zoom-modal__image {
          opacity: 0;
        }
        .product-image-zoom-modal__stage.is-zoomed {
          cursor: grab;
        }
        .product-image-zoom-modal__stage.is-dragging {
          cursor: grabbing;
        }
        .product-image-zoom-modal__image {
          position: absolute;
          top: 50%;
          left: 50%;
          max-width: none;
          max-height: none;
          transform-origin: center center;
          will-change: transform;
          user-select: none;
          -webkit-user-drag: none;
          opacity: 1;
          transition: opacity 0.2s ease;
        }
        @keyframes product-image-zoom-spin {
          to {
            transform: rotate(360deg);
          }
        }
      `;
    document.head.appendChild(style);
  }

  function ensureModal() {
    if (modalElements) return modalElements;

    ensureStyles();

    const modal = document.createElement("div");
    modal.className = "product-image-zoom-modal";
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = `
        <div class="product-image-zoom-modal__backdrop"></div>
        <button type="button" class="product-image-zoom-modal__close" aria-label="Close zoom">
          <svg role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <div class="product-image-zoom-modal__stage">
          <div class="product-image-zoom-modal__loader" aria-hidden="true"></div>
          <img class="product-image-zoom-modal__image" alt="" />
        </div>
      `;

    document.body.appendChild(modal);

    const state = {
      modal,
      backdrop: modal.querySelector(".product-image-zoom-modal__backdrop"),
      close: modal.querySelector(".product-image-zoom-modal__close"),
      stage: modal.querySelector(".product-image-zoom-modal__stage"),
      loader: modal.querySelector(".product-image-zoom-modal__loader"),
      image: modal.querySelector(".product-image-zoom-modal__image"),
      scale: 1,
      minScale: 1,
      maxScale: 4,
      fitScale: 1,
      x: 0,
      y: 0,
      pointerStartX: 0,
      pointerStartY: 0,
      panStartX: 0,
      panStartY: 0,
      pinchStartDistance: 0,
      pinchStartScale: 1,
      dragging: false,
      open: false,
    };

    function getTouchDistance(touchA, touchB) {
      const dx = touchA.clientX - touchB.clientX;
      const dy = touchA.clientY - touchB.clientY;
      return Math.hypot(dx, dy);
    }

    function updateFitScale() {
      const naturalWidth = state.image.naturalWidth;
      const naturalHeight = state.image.naturalHeight;
      const stageRect = state.stage.getBoundingClientRect();

      if (
        !naturalWidth ||
        !naturalHeight ||
        !stageRect.width ||
        !stageRect.height
      ) {
        state.fitScale = 1;
        return;
      }

      const viewportPaddingFactor = 1;
      const fitByWidth =
        (stageRect.width * viewportPaddingFactor) / naturalWidth;
      const fitByHeight =
        (stageRect.height * viewportPaddingFactor) / naturalHeight;
      state.fitScale = Math.min(fitByWidth, fitByHeight);
    }

    function applyTransform() {
      const effectiveScale = state.fitScale * state.scale;
      state.image.style.transform = `translate(-50%, -50%) translate3d(${state.x}px, ${state.y}px, 0) scale(${effectiveScale})`;
      state.stage.classList.toggle("is-zoomed", state.scale > state.minScale);
      state.stage.classList.toggle("is-dragging", state.dragging);
      console.log(state.scale, state.fitScale, effectiveScale);
    }

    function clampPan() {
      const rect = state.image.getBoundingClientRect();
      const stageRect = state.stage.getBoundingClientRect();
      const maxX = Math.max(0, (rect.width - stageRect.width) / 2);
      const maxY = Math.max(0, (rect.height - stageRect.height) / 2);
      state.x = Math.min(maxX, Math.max(-maxX, state.x));
      state.y = Math.min(maxY, Math.max(-maxY, state.y));
    }

    function resetZoom() {
      updateFitScale();
      state.scale = state.minScale;
      state.x = 0;
      state.y = 0;
      state.dragging = false;
      applyTransform();
    }

    function closeModal() {
      if (!state.open) return;
      state.open = false;
      modal.classList.remove("is-open");
      modal.classList.remove("is-loading");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      resetZoom();
    }

    function openModal(imageData) {
      const { src, alt, srcset, sizes } = imageData || {};

      if (!src) return;

      modal.classList.add("is-loading");

      const clearLoadingState = () => {
        modal.classList.remove("is-loading");
        resetZoom();
        state.image.removeEventListener("load", clearLoadingState);
        state.image.removeEventListener("error", clearLoadingState);
      };

      state.image.addEventListener("load", clearLoadingState);
      state.image.addEventListener("error", clearLoadingState);

      if (srcset) {
        state.image.setAttribute("srcset", srcset);
        state.image.setAttribute("sizes", sizes || "100vw");
      } else {
        state.image.removeAttribute("srcset");
        state.image.removeAttribute("sizes");
      }

      state.image.src = src;
      state.image.alt = alt || "";
      state.open = true;
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      if (state.image.complete) {
        clearLoadingState();
      }
    }

    state.backdrop.addEventListener("click", closeModal);
    state.close.addEventListener("click", closeModal);

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeModal();
    });

    state.stage.addEventListener(
      "wheel",
      (event) => {
        if (!state.open) return;
        event.preventDefault();

        const zoomStep = 0.1;
        const delta = event.deltaY > 0 ? -zoomStep : zoomStep;
        const nextScale = Math.max(
          state.minScale,
          Math.min(state.maxScale, state.scale + delta),
        );

        if (nextScale === state.scale) return;
        state.scale = nextScale;
        clampPan();
        applyTransform();
      },
      { passive: false },
    );

    state.stage.addEventListener("mousedown", (event) => {
      if (!state.open || state.scale <= state.minScale) return;
      event.preventDefault();
      state.dragging = true;
      state.pointerStartX = event.clientX;
      state.pointerStartY = event.clientY;
      state.panStartX = state.x;
      state.panStartY = state.y;
      applyTransform();
    });

    window.addEventListener("mousemove", (event) => {
      if (!state.open || !state.dragging) return;
      state.x = state.panStartX + (event.clientX - state.pointerStartX);
      state.y = state.panStartY + (event.clientY - state.pointerStartY);
      clampPan();
      applyTransform();
    });

    window.addEventListener("mouseup", () => {
      if (!state.dragging) return;
      state.dragging = false;
      applyTransform();
    });

    state.stage.addEventListener("dblclick", (event) => {
      event.preventDefault();
      state.scale =
        state.scale > state.minScale ? state.minScale : state.maxScale;
      state.x = 0;
      state.y = 0;
      clampPan();
      applyTransform();
    });

    state.stage.addEventListener(
      "touchstart",
      (event) => {
        if (!state.open) return;

        if (event.touches.length === 2) {
          event.preventDefault();
          state.dragging = false;
          state.pinchStartDistance = getTouchDistance(
            event.touches[0],
            event.touches[1],
          );
          state.pinchStartScale = state.scale;
          applyTransform();
          return;
        }

        if (event.touches.length === 1 && state.scale > state.minScale) {
          event.preventDefault();
          state.dragging = true;
          state.pointerStartX = event.touches[0].clientX;
          state.pointerStartY = event.touches[0].clientY;
          state.panStartX = state.x;
          state.panStartY = state.y;
          applyTransform();
        }
      },
      { passive: false },
    );

    state.stage.addEventListener(
      "touchmove",
      (event) => {
        if (!state.open) return;

        if (event.touches.length === 2 && state.pinchStartDistance > 0) {
          event.preventDefault();
          const distance = getTouchDistance(event.touches[0], event.touches[1]);
          const nextScale = Math.max(
            state.minScale,
            Math.min(
              state.maxScale,
              (distance / state.pinchStartDistance) * state.pinchStartScale,
            ),
          );

          state.scale = nextScale;
          clampPan();
          applyTransform();
          return;
        }

        if (event.touches.length === 1 && state.dragging) {
          event.preventDefault();
          state.x =
            state.panStartX + (event.touches[0].clientX - state.pointerStartX);
          state.y =
            state.panStartY + (event.touches[0].clientY - state.pointerStartY);
          clampPan();
          applyTransform();
        }
      },
      { passive: false },
    );

    state.stage.addEventListener("touchend", (event) => {
      if (!state.open) return;

      if (event.touches.length < 2) {
        state.pinchStartDistance = 0;
      }

      if (event.touches.length === 1 && state.scale > state.minScale) {
        state.dragging = true;
        state.pointerStartX = event.touches[0].clientX;
        state.pointerStartY = event.touches[0].clientY;
        state.panStartX = state.x;
        state.panStartY = state.y;
        applyTransform();
        return;
      }

      if (event.touches.length === 0) {
        state.dragging = false;
        applyTransform();
      }
    });

    state.stage.addEventListener("touchcancel", () => {
      state.dragging = false;
      state.pinchStartDistance = 0;
      applyTransform();
    });

    window.addEventListener("resize", () => {
      if (!state.open) return;
      updateFitScale();
      clampPan();
      applyTransform();
    });

    modalElements = {
      ...state,
      openModal,
      closeModal,
    };

    return modalElements;
  }

  function getSectionImages(sectionId) {
    const slider = document.getElementById(`slider-${sectionId}`);
    if (!slider) return [];

    return Array.from(slider.querySelectorAll(".product-media img"));
  }

  function isMediaVisible(mediaItem) {
    if (!mediaItem) return false;

    const styles = window.getComputedStyle(mediaItem);
    if (styles.display === "none" || styles.visibility === "hidden") {
      return false;
    }

    return mediaItem.offsetParent !== null;
  }

  function bindSection(sectionId) {
    if (!sectionId) return false;

    const prevCleanup = instances.get(sectionId);
    if (typeof prevCleanup === "function") {
      prevCleanup();
    }

    const slider = document.getElementById(`slider-${sectionId}`);
    if (!slider) {
      instances.set(sectionId, null);
      return false;
    }

    const images = getSectionImages(sectionId);
    const modal = ensureModal();
    images.forEach((image) => {
      image.style.cursor = "zoom-in";
    });

    const listener = (event) => {
      if (!(event.target instanceof Element)) return;

      const image = event.target.closest(".product-media img");
      if (!image || !slider.contains(image)) return;

      const mediaItem = image.closest(".product-media");
      if (!isMediaVisible(mediaItem)) return;

      event.preventDefault();
      const src = image.currentSrc || image.getAttribute("src") || image.src;
      if (!src) return;

      const zoomSrc = image.getAttribute("data-zoom-src") || src;
      const zoomSrcset =
        image.getAttribute("data-zoom-srcset") || image.getAttribute("srcset");
      const zoomSizes = image.getAttribute("data-zoom-sizes") || "100vw";

      modal.openModal({
        src: zoomSrc,
        alt: image.alt || "",
        srcset: zoomSrcset,
        sizes: zoomSizes,
      });
    };

    slider.addEventListener("click", listener, true);

    instances.set(sectionId, () => {
      slider.removeEventListener("click", listener, true);
      images.forEach((image) => {
        if (image.style.cursor === "zoom-in") {
          image.style.cursor = "";
        }
      });
    });

    return true;
  }

  window.ProductImageZoom = {
    initForSection(sectionId) {
      let retries = 0;

      const bindWithRetry = () => {
        const isBound = bindSection(sectionId);
        if (isBound || retries >= 10) return;

        retries += 1;
        window.requestAnimationFrame(bindWithRetry);
      };

      bindWithRetry();
    },
  };
})();
